<template>
    <Modal
        :onClose="handleClose"
        :title="t({ key: 'cancellation.cancellation_policy' })"
        padding="m"
        size="m">
        <div class="modal-info">
            <div class="modal-info-disclaimer">
                <span>{{
                    t({
                        key: 'cancellation.cancellation_policy_terms',
                    })
                }}</span>
            </div>
            <BookingCancellation v-if="dataType === 'booking'" :product="product" />
        </div>
    </Modal>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import {
        ActivityProduct as ActivityBookingProduct,
        HotelProduct as HotelBookingProduct,
    } from '@/api/MyBooking/myBooking.interfaces';
    import BookingCancellation from '@/components/shared/Cancellation/BookingCancellation/BookingCancellation.vue';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'ProductCancellationModal',
        methods: { t },
        components: { BookingCancellation, Modal },
        props: {
            product: {
                type: Object as PropType<HotelBookingProduct | ActivityBookingProduct>,
                required: true,
            },
            dataType: {
                type: String as PropType<'cart' | 'booking'>,
                required: true,
            },
            onClose: Function,
        },
        setup({ onClose }) {
            const handleClose = () => {
                onClose && onClose();
            };

            return { handleClose };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'ProductCancellation.scss';
</style>
